module.exports = __webpack_public_path__ + "img/FR25833.b3a94a49.png";